import React, { useEffect } from "react";

import useHttpHook from "../../../Hooks/HttpHook";
import { useForm } from "react-hook-form";

import { CreateAddonsApi } from "../../../utils/ApiConstant";
import { useParams } from "react-router-dom";

import Input from "../../UiElement/FormElement/Input";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import MainComponentWrapper from "../../Common/MainComponentWrapper";

const CreateAddonModal = (props) => {
  const { show, onClose, addon } = props;
  const [loading, sendRequest, error] = useHttpHook();
  const { eventId } = useParams();
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    setError,
    setValue,
    watch,
  } = useForm({});
  const onSubmit = async (data) => {
    let response = await sendRequest(CreateAddonsApi + eventId, {
      method: addon?._id ? "put" : "post",
      data: {
        ...data,
        addonId: addon?._id,
      },
    });
    if (response.status === 1) {
      onClose();
      reset();
      props.getAddons();
    }
  };
  useEffect(() => {
    if (addon?._id) {
      setValue("redirectionLink", addon.redirectionLink);
    }
  }, [addon]);

  useEffect(() => {
    if (error) {
      setError(
        "redirectionLink",
        {
          type: "manual",
          message: error,
        },
        {
          shouldFocus: true,
        }
      );
    }
  }, [error]);

  console.log(errors);

  return (
    <MainComponentWrapper loading={loading} errorInfo={error}>
      <ModalWrapper
        title={addon?._id ? "Edit Add-on" : "Create Add-on"}
        OverRideModal={true}
        size="md"
        ShowModal={show}
        CloseModalHandler={() => {
          reset();
          onClose();
        }}
        submitText={addon?._id ? "Update" : "Create"}
        // clickHandler={() => props.CloseModal()}
        formId="addonForm"
        isLoading={loading}
      >
        <form
          className="ticketModal"
          onSubmit={handleSubmit(onSubmit)}
          id="addonForm"
        >
          <div className="evntUserInfo bg-F9F9F9">
            <Input
              element="text"
              placeholder="https://dev.danzflo.com/{productId} or /merch/product/{id}"
              Register={register}
              Errors={errors ?? {}}
              FieldName="redirectionLink"
              Label={"Addon Link"}
              ValidationArr={[
                { Type: "required" },
                { Type: "minLength", value: 1 },
              ]}
            />
          </div>
        </form>
      </ModalWrapper>
    </MainComponentWrapper>
  );
};

export default CreateAddonModal;
